<template>
    <div>
        <div class="checkout-project-info-page-container">
            <section class="text-center bg-white main-heading-page">
                <h2>                    
                    {{ $resourceString["checkout.Title.ProjectInformation"] }}                    
                </h2>
            </section>
            <div class="container-fluid">
                <div class="row align-items-start">
                    <div class="col-12 col-lg-8 col-xl-9">
                        <div class="checkout-project-info-page-wrap">
                            <div class="row">
                                <div class="col-md-12">
                                    <h5 class="primary-heading font-weight-bold">
                                        {{ $resourceString['checkout.ProjectInformation.Title.MainHeading'] }} 
                                        <span class="required-label">{{ $resourceString['common.Label.Required'] }}</span>
                                    </h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                     <div class="checkout-project-info-page-details">
                                         <div class="checkout-project-info-page-form">
                                            <!-- Salesforce Opportunities -->
                                            <pc-salesforce-opportunities 
                                             :user-email="userEmail" 
                                             :edit-opportunities-data="opportunityData"
                                             @contact-found="handleContactFound"
                                             @update-project-name="updateProjectName" 
                                             @update-loader="handleUpdateLoader"
                                             @update-is-enabled="handleIsEnabled"
                                             />

                                            <!-- Project Name Field (hidden when an opportunity is found) -->
                                              <div class="checkout-project-info-select-project-col" v-if="contactFound !== null && contactFound === false">                                                
                                                 <div class="checkout-project-info-select-project form-group-control">
                                                    <label>{{ $resourceString["checkout.Project.Title"] }}</label>
                                                    <div class="form-input-box">
                                                        <input
                                                            class="form-control"
                                                            type="text"
                                                            id="enternewproject"
                                                            name="enternewproject"
                                                            v-model="projectName"
                                                            @input="submitProjectName"
                                                            :placeholder="$resourceString['checkout.Placeholder.ProjectName']" 
                                                        />                                                       
                                                        <span class="field-validation-error text-secondary" v-if="getValidationErrorPName">
                                                           {{ $resourceString["checkout.ProjectName.ValidationError"] }}
                                                        </span>
                                                    </div>                                                   
                                                 </div>                                                 
                                              </div>                                             
                                         </div>

                                     </div>
                                </div>
                            </div>                            
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-xl-3 sidebar-position-sticky">
                        <div class="checkout-basket-sidebar-warpper">
                            <div class="checkout-basket-sidebar-container">
                                <pc-basket-sidebar
                                    :individualSamples="checkoutItemList.siteItems.length > 0"
                                    :individualSamplesCount="checkoutItemCount.siteItems"
                                    :projectSamples="checkoutItemList.projectItems.length > 0"
                                    :projectSamplesCount="checkoutItemCount.projectItems"
                                    :designTraySample="checkoutItemList.trayItems.length > 0"
                                    :designTraySampleCount="checkoutItemCount.trayItems"
                                    :backLabel="$resourceString['checkout.Button.BackToShipping']"
                                    :backAction="backHandler"
                                    :nextLabel="$resourceString['checkout.Button.ReviewBasket']"
                                    :nextAction="nextHandler"
                                    :isNextDisabled="!this.checkoutData.ProjectName || !isProjectValid"
                                    :isError="!isProjectValid || getValidationErrorPName"
                                    :errorMsg="isProjectValidError"        
                                /> 
                            </div>
                        </div>
                    </div>

                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"; 
import pcBasketSidebar from "../new-basket-page/pc-basket-sidebar.vue";
import { CHECKOUT_SHIPPING, CHECKOUT_REVIEW_BASKET } from "../../../constants/checkout-constant";
import SalesforceOpportunities from "./pc-salesforce-opportunities.vue";

export default {
    props: {
        userEmail: String,
    },
    data() {
        return {
           projectName: '',
           contactFound: null,
           isProjectValidError: '',
           isEnabled: true
        }
    },
    components: {
        pcBasketSidebar,
        "pc-salesforce-opportunities": SalesforceOpportunities,
    },
    watch: {
        checkoutData() {
             if (!this.projectName && this.checkoutData.ProjectName) {
                this.projectName = this.checkoutData.ProjectName;
            }
        }
    },

    created() { },
    computed: {
        ...mapGetters({
            getValidationErrorPName: "newCheckoutPage/getValidationErrorPName",
            checkoutData: "newCheckoutPage/checkoutData",
            checkoutItemCount: "newCheckoutPage/getCheckoutItemCount",
            checkoutItemList: "newCheckoutPage/checkoutItemList",
            opportunityData: "newCheckoutPage/opportunityData",
            opportunityName: "newCheckoutPage/opportunityName",
            opportunityType: "newCheckoutPage/opportunityType",
            opportunityAccountId: "newCheckoutPage/opportunityAccountId",
            opportunityDynamicProperties: "newCheckoutPage/opportunityDynamicProperties"            
        }),
        isProjectValid() {
            if(this.opportunityName && this.opportunityName !== ""){
                return !!(this.opportunityName && this.opportunityType && this.opportunityAccountId);
            } else {
                return true
            }
        }
    },
    methods: {
        ...mapActions({
            updateCheckoutStep: "newCheckoutPage/updateCheckoutStep",
            updateProjectName: "newCheckoutPage/updateProjectName",
            updateValidationErrorPName: "newCheckoutPage/updateValidationErrorPName",
            updateLoader: "newCheckoutPage/updateLoader",
        }),
        submitProjectName() {
            this.updateProjectName(this.projectName);
        },
        handleIsEnabled(value) {
            this.isEnabled = value;
        },
        handleContactFound(found) {
            // If Salesforce is disabled, force the project name field to show
            if (this.isEnabled === false) {
                this.contactFound = false;
            } else {
                this.contactFound = found;
            }

            // If Salesforce is disabled or no contact was found, restore project name
            if (this.contactFound === false) {
                this.projectName = this.checkoutData.ProjectName || '';
            } else {
                this.updateProjectName('');
            }
        },

        handleUpdateLoader(value) {
            this.updateLoader(value)
        },
       
        backHandler() {
            this.updateCheckoutStep(CHECKOUT_SHIPPING);
        },
        nextHandler() {
            if(this.checkoutData.ProjectName && !this.getValidationErrorPName && this.isProjectValid) {
                this.updateValidationErrorPName(false)
                this.updateCheckoutStep(CHECKOUT_REVIEW_BASKET)
            } else if(!this.isProjectValid) {
                this.isProjectValidError = this.$resourceString["checkout.ProjectSalesforceOpportunity.ValidationError"]
            } else {            
                this.isProjectValidError = this.$resourceString["checkout.ProjectName.ValidationError"]
                this.updateValidationErrorPName(true)
            }
        }
    }
}
</script>